// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signOut, getCurrentUser } from '@aws-amplify/auth';
import './Header.css';

const Header = ({ currentPage = 'app' }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut();
      setIsAuthenticated(false);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
      navigate('/');
    }
  };

  const getNavLinks = () => {
    // If authenticated, always show authenticated navigation
    if (isAuthenticated) {
      switch (currentPage) {
        case 'app':
          return [
            { to: '/app', label: 'Quick Notes', active: true },
            { to: '/pack-it', label: 'Trip Pack-it' },
            { to: '/account-settings', label: 'Account Settings' },
            { to: '/startup-guide', label: 'Startup Guide' }
          ];
        case 'pack-it':
          return [
            { to: '/app', label: 'Quick Notes' },
            { to: '/pack-it', label: 'Trip Pack-it', active: true },
            { to: '/account-settings', label: 'Account Settings' },
            { to: '/startup-guide', label: 'Startup Guide' }
          ];
        case 'account-settings':
          return [
            { to: '/app', label: 'Quick Notes' },
            { to: '/pack-it', label: 'Trip Pack-it' },
            { to: '/account-settings', label: 'Account Settings', active: true },
            { to: '/startup-guide', label: 'Startup Guide' }
          ];
        case 'startup-guide':
          return [
            { to: '/app', label: 'Quick Notes' },
            { to: '/pack-it', label: 'Trip Pack-it' },
            { to: '/account-settings', label: 'Account Settings' },
            { to: '/startup-guide', label: 'Startup Guide', active: true }
          ];
        case 'home':
          return [
            { to: '/app', label: 'Quick Notes', active: true },
            { to: '/pack-it', label: 'Trip Pack-it' },
            { to: '/account-settings', label: 'Account Settings' },
            { to: '/startup-guide', label: 'Startup Guide' }
          ];
        default:
          return [
            { to: '/app', label: 'Quick Notes' },
            { to: '/pack-it', label: 'Trip Pack-it' },
            { to: '/account-settings', label: 'Account Settings' },
            { to: '/startup-guide', label: 'Startup Guide' }
          ];
      }
    }

    // If not authenticated, show public navigation
    switch (currentPage) {
      case 'auth':
        return [
          { to: '/', label: 'Home' },
          { to: '/auth', label: 'Sign In', active: true }
        ];
      case 'startup-guide':
        return [
          { to: '/', label: 'Home' },
          { to: '/auth', label: 'Sign In' }
        ];
      case 'home':
        return [
          { to: '/', label: 'Home', active: true },
          { to: '/auth', label: 'Sign In' }
        ];
      default:
        return [
          { to: '/', label: 'Home' },
          { to: '/startup-guide', label: 'Startup Guide' }
        ];
    }
  };

  return (
    <header className="header">
      <div className="banner">
        <div className="banner-left">
          <Link to="/" className="logo-container">
            <img 
              src="/idealscribelogo.png" 
              alt="Ideal Scribe" 
              className="logo"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div className="logo-fallback" style={{ display: 'none' }}>
              <span className="logo-text">IS</span>
            </div>
          </Link>
          <span className="beta-label">beta</span>
        </div>
        <nav className="nav-links">
          {getNavLinks().map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={link.active ? 'active' : ''}
            >
              {link.label}
            </Link>
          ))}
          {isAuthenticated && (
            <button className="night-mode-toggle" onClick={handleLogout}>
              Logout
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
